<template>
  <div class="alibabaorder">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">開始代購吧</a>
        <div v-if="addToCartCount > 0">
          <button
            type="button"
            class="btn btn-primary addCarButton"
            @click="goToShoppingCart()"
          >
            購物車
            <span class="badge badge-light">{{ addToCartCount }}</span>
          </button>
        </div>
      </nav>

      <div v-if="addToCartCount == 0">
        <div class="title pt-3">Step1.加入委託代購商品</div>
        <b-alert show variant="info"
          >申請委託單都是免費的，得到代買幫報價後都可以取消委託單，低風險批貨，如果使用App阿里巴巴抓取網址長按商品名稱獲取</b-alert
        >
        <ul class="list-group">
          <div class="card">
            <div class="card-body">
              <p>
                阿里巴巴網址範例:
                <br />
                https://detail.1688.com/offer/800120939317.html 或
                https://m.1688.com/offer/800120939317.html
              </p>
              <p>
                請將阿里巴巴(1688)中國購物平台商品網址複製後，貼入下方輸入框，在點選「加入商品」:
              </p>
              <input type="text" class="form-control" v-model="searchUrl" />
              <br />
              <button
                class="btn btn-primary btn-block"
                v-on:click="clickSearchUrl()"
              >
                加入商品
              </button>
            </div>
          </div>
        </ul>
      </div>

      <!--  /////////////////////////////// -->
      <div v-if="displayViews != null">
        <div class="title pt-3">Step2.代買商品</div>
        <div class="card">
          <div class="card-body">
            <h5>{{ displayViews.prod_name }}</h5>
            <p>*請注意此商品起批數為{{ buyBaseLine }}</p>
            <p>顏色:</p>
            <br />
            <div class="row">
              <div
                class="card col-6"
                style="margin: 0 auto; float: none; margin-bottom: 10px"
                v-for="(color_info, color_index) in displayViews.color_info"
                v-bind:key="(color_info, color_index)"
              >
                <img
                  class="card-img-top"
                  v-bind:src="color_info.color_image"
                  style="width: 100%"
                  alt="Card image cap"
                  referrerpolicy="no-referrer"
                />
                <div class="card-body">
                  <h5>{{ color_info.color_name }}</h5>
                  <div class="card-text">
                    <b-form-group label="選取:" class="col-12 pt-2">
                      <div>
                        <b-form-radio
                          v-model="colorSelected"
                          name="some-radios"
                          v-bind:value="color_index"
                          >{{ color_info.color_name }}</b-form-radio
                        >
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <h6>規格:</h6>
              </div>

              <div
                class="col-12"
                v-for="(sku_info, index) in displayViews.sku_info"
                v-bind:key="(sku_info, index)"
              >
                <div class="row">
                  <div class="col-2">
                    <p>{{ sku_info.sku_name }}</p>
                  </div>
                  <div class="col-4">
                    <p>價格:{{ sku_info.sku_price }}</p>
                  </div>
                  <div class="col-6">
                    <p>數量:</p>

                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          @click="lessAmounts(index)"
                        >
                          -
                        </button>
                      </div>
                      <input
                        type="number"
                        class="form-control"
                        placeholder
                        aria-label="inputAmounts"
                        v-model="skuInfo[index].amount"
                        @change="updateAmounts(index)"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          @click="addAmounts(index)"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-3 mb-3">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="ignoreBaseLine"
                  name="checkbox-1"
                  value="false"
                  unchecked-value="true"
                  @change="ignoreBaseLineCheck(ignoreBaseLine)"
                  >打樣商品(只購買一個)</b-form-checkbox
                >
              </div>

              <div class="col-12">
                <h6>備註細節:</h6>
              </div>
              <div class="col-12">
                <b-form-textarea
                  id="textarea-rows"
                  placeholder="例如:需要與廠商溝通降低起批數，需要廠商特別配合...等"
                  rows="2"
                  v-model="prodDetail"
                ></b-form-textarea>
              </div>
            </div>
          </div>
        </div>
        <!-- <p>請到 Step1 填入你要買的商品網址</p> -->
      </div>
      <!--  /////////////////////////////// -->

      <div v-if="displayViews != null">
        <br />
        <button class="btn btn-danger btn-lg btn-block" @click="submit()">
          加入到購物車
        </button>
        <br />
        <button
          type="button"
          class="btn btn-primary btn-lg btn-block"
          @click="goToShoppingCart()"
        >
          前往購物車，完成委託單申請
          <span class="badge badge-light">{{ addToCartCount }}</span>
        </button>

        <div v-if="addToCartCount > 0">
          <br />
          <div class="alert alert-success" role="alert">
            將購物車清空就可以重新加入其他委託代購商品!
          </div>
        </div>
      </div>

      <br />
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'
export default {
  name: 'alibabaorder',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      displayViews: null,
      skuInfo: [],
      buyBaseLine: 1,
      isLoading: true,
      searchUrl: '',
      mapInfo: null,
      prodInfos: {},
      ProdInfosArray: [],
      inputAmounts: [],
      colorSelected: null,
      selectedStore: 'UNIMARTC2C',
      checkMobile: isMobile ? '1' : '0',
      prodDetail: '',
      ignoreBaseLine: true,
      addToCartCount: 0,
    }
  },
  methods: {
    submit: function () {
      const vm = this

      if (vm.displayViews.color_info.length > 0) {
        if (vm.colorSelected == null) {
          vm.$toast.open({
            message: '請選擇顏色!',
            type: 'error',
          })
          return 0
        }
      }

      if (vm.skuInfo.length > 0) {
        let count = 0
        vm.skuInfo.forEach(element => {
          count = parseInt(count) + parseInt(element.amount)
        })
        if (count == 0) {
          vm.$toast.open({
            message: '請輸入數量!',
            type: 'error',
          })
          return 0
        }
        //   } else if (count < vm.buyBaseLine && vm.ignoreBaseLine == "nonignore") {
        //     vm.$toast.open({
        //       message: "注意低於起批數量" + vm.buyBaseLine + "個",
        //       type: "error"
        //     });
        //     return 0;
        //   }
      }

      if (vm.displayViews != null) {
        vm.prodInfos['prod_name'] = vm.displayViews.prod_name
        vm.prodInfos['buy_base_line'] = vm.displayViews.buy_base_line
        vm.prodInfos['prod_url'] = vm.displayViews.prod_url
        try {
          vm.prodInfos['color_name_selected'] =
            vm.displayViews.color_info[vm.colorSelected].color_name
          vm.prodInfos['color_image_selected'] =
            vm.displayViews.color_info[vm.colorSelected].color_image
        } catch (e) {
          // console.error(e);
        }
        vm.prodInfos['sku_info'] = JSON.parse(JSON.stringify(vm.skuInfo))
        vm.prodInfos['color_info'] = JSON.parse(
          JSON.stringify(vm.displayViews.color_info)
        )
        vm.prodInfos['prod_length'] = 0
        vm.prodInfos['prod_width'] = 0
        vm.prodInfos['prod_height'] = 0
        vm.prodInfos['prod_weight'] = 0
        vm.prodInfos['prod_detail'] = vm.prodDetail

        vm.ProdInfosArray.push(vm.prodInfos)
        vm.$store.prodInfos = vm.ProdInfosArray
        localStorage.setItem('prodInfos', JSON.stringify(vm.ProdInfosArray))
        vm.prodInfos = {}
        vm.skuInfo = vm.displayViews.sku_info

        let index = 0
        vm.displayViews.sku_info.forEach(function () {
          vm.skuInfo[index].amount = 0
          vm.skuInfo[index].prod_weight = 0
          vm.skuInfo[index].prod_length = 0
          vm.skuInfo[index].prod_width = 0
          vm.skuInfo[index].prod_height = 0
          index++
        })
        vm.prodDetail = ''

        vm.addToCartCount = vm.ProdInfosArray.length

        vm.$toast.open({
          message: vm.displayViews.prod_name + ' 加入購物車!',
          type: 'success',
        })
        vm.$forceUpdate()
        // vm.$router.push("profile");
      }
    },
    goToShoppingCart: function () {
      const vm = this
      // let count = 0;

      // vm.ProdInfosArray.forEach(function (prodInfo) {
      //   if (prodInfo.sku_info.length > 0) {
      //     prodInfo.sku_info.forEach(element => {
      //       count = parseInt(count) + parseInt(element.amount);
      //     });
      //   }
      // });

      // if (count == 0) {
      //   vm.$toast.open({
      //     message: "請輸入數量!",
      //     type: "error"
      //   });
      //   return 0;
      // } else if (count < vm.buyBaseLine && vm.ignoreBaseLine == "nonignore") {
      //   vm.$toast.open({
      //     message: "注意低於起批數量" +
      //       vm.buyBaseLine + "個",
      //     type: "error"
      //   });
      //   return 0;
      // } else {
      //   vm.$router.push("shoppingcart");
      // }

      vm.$router.push('shoppingcart')
    },
    clickSearchUrlFormat: function (url) {
      const vm = this
      // https: //detail.1688.com/offer/571008951577.html 或
      //   https: //m.1688.com/offer/571008951577.html 或
      // http://detail.m.1688.com/page/index.htm?offerId=601733052815

      let aibabaRegexs = []
      let isAibabaUrl = false
      let desktopAibabaRegex = /detail.1688.com\/offer\/[0-9]{8,12}/g
      let mobileAibabaRegex = /m.1688.com\/offer\/[0-9]{8,12}/g
      let mobileAppAibabaRegex =
        /detail.m.1688.com\/page\/index\.htm\?offerId=[0-9]{8,12}/g

      aibabaRegexs.push(desktopAibabaRegex)
      aibabaRegexs.push(mobileAibabaRegex)
      aibabaRegexs.push(mobileAppAibabaRegex)

      let checkMatchAibabaUrl = []
      let matchAibabaOfferId = ''
      aibabaRegexs.forEach(aibabaRegex => {
        checkMatchAibabaUrl = url.match(aibabaRegex)

        if (
          checkMatchAibabaUrl != undefined &&
          checkMatchAibabaUrl.length != 0
        ) {
          if (checkMatchAibabaUrl[0].split('offer/')[1] != undefined) {
            matchAibabaOfferId = checkMatchAibabaUrl[0].split('offer/')[1]
          } else if (checkMatchAibabaUrl[0].split('offerId=')[1] != undefined) {
            matchAibabaOfferId = checkMatchAibabaUrl[0].split('offerId=')[1]
          } else {
            isAibabaUrl = false
          }

          isAibabaUrl = true
        }
      })

      if (isAibabaUrl) {
        vm.searchUrl =
          'https://detail.1688.com/offer/' + matchAibabaOfferId + '.html'

        return true
      } else {
        vm.$toast.open({
          message: '輸入的 ' + vm.searchUrl + ' 網址格式錯誤',
          type: 'error',
        })
        vm.isLoading = false
        return false
      }
    },
    clickSearchUrl: function () {
      const vm = this
      vm.isLoading = true

      let urlIsValid = vm.clickSearchUrlFormat(vm.searchUrl)

      if (urlIsValid) {
        vm.$toast.open({
          message: '解析網站中，大概需要15秒，請稍等片刻...',
          type: 'success',
        })

        let formData = {
          parseUrl: vm.searchUrl,
        }
        axios
          .post(vm.apiUrl + 'ParseDataToDb', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            vm.displayViews = response.data
            // console.log(JSON.stringify(vm.displayViews));
            vm.buyBaseLine = vm.parseAlibabaBaseLine(vm.displayViews)
            vm.displayViews.prod_url = vm.searchUrl
            vm.displayViews.buy_base_line = vm.buyBaseLine

            localStorage.setItem(
              'recommendInfo',
              JSON.stringify(vm.displayViews.recommend_info)
            )

            vm.skuInfo = []
            vm.skuInfo = vm.displayViews.sku_info

            let index = 0
            vm.displayViews.sku_info.forEach(function () {
              vm.skuInfo[index].amount = 0
              vm.skuInfo[index].prod_weight = 0
              vm.skuInfo[index].prod_length = 0
              vm.skuInfo[index].prod_width = 0
              vm.skuInfo[index].prod_height = 0
              index++
            })

            //   console.log(response.data);
            vm.isLoading = false

            vm.$toast.open({
              message: '解析成功',
              type: 'success',
            })
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '解析失敗: ' + error,
              type: 'error',
            })
            vm.$modal.show('dialog', {
              title: '🙋請聯絡客服',
              text: '請聯絡客服⚡ 告訴我們您網站解析發生了問題!',
              buttons: [
                {
                  title: '👉聯絡客服',
                  handler: () => {
                    window.location = 'https://m.me/2266831083395361'
                  },
                },
              ],
            })
          })
      }
    },
    parseAlibabaBaseLine: function (data) {
      let baseLine = 1
      if (data.amount_info.length >= 1) {
        let amountString = data.amount_info[0].amount_count

        if (amountString.startsWith('≥')) {
          baseLine = amountString.split('≥')[1]
        } else if (amountString.indexOf('-') !== -1) {
          baseLine = amountString.split('-')[0]
        }
      }
      return baseLine
    },
    updateAmounts: function () {
      const vm = this
      // console.log(JSON.stringify(vm.skuInfo[index]));
      vm.$forceUpdate()
    },
    lessAmounts: function (index) {
      const vm = this

      let amount = Number(vm.skuInfo[index].amount) - 1
      if (!amount || amount <= 0) {
        amount = 0
      }

      vm.skuInfo[index].amount = amount

      // console.log(JSON.stringify(vm.skuInfo));
      vm.updateAmounts(index)
    },
    addAmounts: function (index) {
      const vm = this
      let amount = Number(vm.skuInfo[index].amount) + 1
      if (!amount) {
        amount = 1
      }

      vm.skuInfo[index].amount = amount

      // console.log(JSON.stringify(vm.skuInfo));
      vm.updateAmounts(index)
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (localStorage.userId == undefined) {
        if (vm.userId.length == 0) {
          vm.$modal.show('dialog', {
            title: '🙋您尚未登入FB會員',
            text: '請先登入才能使用此服務喔⚡',
            buttons: [
              {
                title: '👉用FB登入',
                handler: () => {
                  window.location = 'https://m.me/2266831083395361'
                },
              },
            ],
          })
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    ignoreBaseLineCheck: function (ignoreBaseLine) {
      const vm = this
      vm.$store.state.ignoreBaseLine = ignoreBaseLine
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = false
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    // Event snippet for 進入機器人解析阿里巴巴網站page conversion page
    vm.$ga.event('event', 'conversion', {
      send_to: 'AW-700538278/FijJCLLZ3LIBEKa7hc4C',
      value: 1.0,
      currency: 'TWD',
    })

    vm.checkUnChatbotSignin()

    if (vm.$store.prodInfos != undefined) {
      vm.ProdInfosArray = vm.$store.prodInfos.concat()
      vm.displayViews = JSON.parse(JSON.stringify(vm.ProdInfosArray[0]))

      vm.skuInfo = vm.displayViews.sku_info
      let index = 0
      vm.displayViews.sku_info.forEach(function () {
        vm.skuInfo[index].amount = 0
        vm.skuInfo[index].prod_weight = 0
        vm.skuInfo[index].prod_length = 0
        vm.skuInfo[index].prod_width = 0
        vm.skuInfo[index].prod_height = 0
        index++
      })
      vm.prodDetail = ''
      vm.addToCartCount = vm.ProdInfosArray.length

      vm.isLoading = false
    } else if (JSON.parse(localStorage.getItem('prodInfos')) != undefined) {
      vm.ProdInfosArray = JSON.parse(localStorage.getItem('prodInfos')).concat()
      vm.displayViews = JSON.parse(JSON.stringify(vm.ProdInfosArray[0]))

      // console.log(vm.displayViews);
      vm.skuInfo = vm.displayViews.sku_info
      let index = 0
      vm.displayViews.sku_info.forEach(function () {
        vm.skuInfo[index].amount = 0
        vm.skuInfo[index].prod_weight = 0
        vm.skuInfo[index].prod_length = 0
        vm.skuInfo[index].prod_width = 0
        vm.skuInfo[index].prod_height = 0
        index++
      })
      vm.prodDetail = ''
      vm.addToCartCount = vm.ProdInfosArray.length

      vm.isLoading = false
    }
  },
}
</script>
